import { FC } from 'react';

import { ErrorBox } from '../../components/errorBox';

interface UserInputErrorProps {
  traceId?: string | null;
}

export const UserInputError: FC<UserInputErrorProps> = ({ traceId }) => (
  <ErrorBox
    titleKey="registerScreen.loadRegistrationFailed.title"
    descriptionKey="registerScreen.loadRegistrationFailed.description"
    traceId={traceId}
  />
);
